var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-progress',{staticStyle:{"width":"100%"},attrs:{"text-inside":true,"stroke-width":22,"color":_vm.computeOrderProgressColor(),"percentage":_vm.progress}})
}
var staticRenderFns = []

export { render, staticRenderFns }